import { createContext } from 'react';
import { AccountContextValue, TagContextValue } from '../types';

export const initialValue: TagContextValue = {
  loading: true,
  tagData: null,
};
export const initialAccountValue: AccountContextValue = {
  loading: true,
  accountName: '',
  ABTastyUA: {
    type: '',
    os: { name: '', version: '1' },
    is_bot: false,
    browser: { name: '', version: '1.1' },
  },
  flagship: {},

  fetchAccountInfo: async () => {},
  packageName: 'N/A',
};

export const TagContext = createContext<TagContextValue>(initialValue);
export const AccountContext = createContext<AccountContextValue>(initialAccountValue);
